import React, { useEffect, useState } from 'react';
import {
    Button,
    Dialog, DialogActions, DialogContent, DialogTitle,
    Typography, makeStyles
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

const useStyles = makeStyles((theme) => ({
    customDialogPaper: (props) => ({
        width: props.dialogWidth || 428,
        border: '1px solid rgba(224, 224, 224, 1)',
        borderRadius: '8px',
        maxWidth: 'none',
    }),
    inputField: {
        width: "100%",
        height: "35px",
        paddingLeft: "5px"
    },
    smallOutlinedInput: {
        fontSize: '12px', 
        height: '32px',
        padding: '5px 8px 6px 8px',
        '& input': {
            padding: '5px 4px 6px 4px',
            fontSize: '12px',
        },
    },
    smallNotchedOutline: {
        fontSize: '12px',
        borderColor: '#ccc', 
    },
}));

const WorkFlowModelViewer = (props) => {
    const {
        appId, members, toggleCompareModal, modalInfo, block, formHeaders,
        onSaveHandler, currentOpportunityId, selectedStep, chartUniqueId,
        formData, loader, dataModel, classes, allValues, onCloseModel, onAssignTo, onSucessClick, onRejectedModel, defaultOptionsDropdown, onAssignToParent
    } = props;
    const { document } = formData;

    const classesss = useStyles({ dialogWidth: (modalInfo.type === 'view' || modalInfo.type === 'edit' || modalInfo.type === 'assignTo') ? 428 : (modalInfo.type === 'success' ? 300 : (modalInfo.type === 'rejected' ||  modalInfo.type === 'completed' || modalInfo.type === 'deleteTaskConfimation' ? 300 : 428)) });

    const [selectedAssigneeId, setSelectedAssigneeId] = useState({});

    useEffect(() => {
        if (modalInfo.enable) {
            if (modalInfo.type === 'assignTo') {

            }
            if (modalInfo.type === 'success') {

            }
            if (modalInfo.type === 'rejected') {

            }
        }
    }, [modalInfo]);

    return (
        <Dialog
            open={modalInfo.enable}
            fullWidth={true}
            classes={{ paper: classesss.customDialogPaper }}
            maxWidth={'md'}
            aria-labelledby='comparision-dialog-title'
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
        >
            {
                modalInfo.type === 'success' && (
                    <div>
                        <DialogContent>
                            <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '24px', gap: '16px' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img
                                        src={'/media/svg/moveNext.svg'}
                                        alt="Move Next"
                                        width="48px"
                                        height="48px"
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Typography
                                            component='span'
                                            style={{ fontWeight: '400', fontSize: '14px', color: 'rgba(33, 33, 33, 1)', fontStyle: 'medium' }}
                                        >
                                            Successfully Moved
                                        </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Typography
                                            component='span'
                                            style={{ fontWeight: '400', fontSize: '12px', color: 'rgba(97, 97, 97, 1)', fontStyle: 'medium', textAlign: 'center' }}
                                        >
                                            {modalInfo.message}
                                        </Typography>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Button
                                        style={{ backgroundColor: 'rgba(46, 125, 50, 1)', color: 'rgba(255, 255, 255, 1)' }}
                                        size='small'
                                        onClick={() => { onSucessClick() }}

                                    >
                                        OKAY
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </div>
                )
            }
            {
                modalInfo.type === 'completed' && (
                    <div>
                        <DialogContent>
                            <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '24px', gap: '16px' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img
                                        src={'/media/svg/moveNext.svg'}
                                        alt="Move Next"
                                        width="48px"
                                        height="48px"
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Typography
                                            component='span'
                                            style={{ fontWeight: '400', fontSize: '14px', color: 'rgba(33, 33, 33, 1)', fontStyle: 'medium' }}
                                        >
                                            Completed
                                        </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Typography
                                            component='span'
                                            style={{ fontWeight: '400', fontSize: '12px', color: 'rgba(97, 97, 97, 1)', fontStyle: 'medium', textAlign: 'center' }}
                                        >
                                            Opportunity Successfully Completed
                                        </Typography>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Button
                                        style={{ backgroundColor: 'rgba(46, 125, 50, 1)', color: 'rgba(255, 255, 255, 1)' }}
                                        size='small'
                                        onClick={() => { onSucessClick() }}

                                    >
                                        OKAY
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </div>
                )
            }
            {
                modalInfo.type === 'rejected' && (
                    <div>
                        <DialogContent>
                            <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '24px', gap: '16px' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img
                                        src={'/media/svg/movePrevious.svg'}
                                        alt="Move Previous"
                                        width="48px"
                                        height="48px"
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Typography
                                            component='span'
                                            style={{ fontWeight: '400', fontSize: '14px', color: 'rgba(33, 33, 33, 1)', fontStyle: 'medium' }}
                                        >
                                            Rejected
                                        </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Typography
                                            component='span'
                                            style={{ fontWeight: '400', fontSize: '12px', color: 'rgba(97, 97, 97, 1)', fontStyle: 'medium', textAlign: 'center' }}
                                        >
                                            The document has been Rejected moved to the implementation process
                                        </Typography>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Button
                                        style={{ backgroundColor: 'rgba(46, 125, 50, 1)', color: 'rgba(255, 255, 255, 1)' }}
                                        size='small'
                                        onClick={() => { onRejectedModel() }}

                                    >
                                        OKAY
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </div>
                )
            }
            {
                modalInfo.type === 'assignTo' && (
                    <div>
                        <DialogTitle id='customized-dialog-title'>
                            <Typography component='span' style={{ fontWeight: '600', fontSize: '14px', color: 'rgba(33, 33, 33, 1)', fontStyle: 'normal' }}>
                                {modalInfo.title}
                            </Typography>
                        </DialogTitle>
                        <DialogContent dividers>
                            <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                {
                                    (props.formData?.[props.data.chartUniqueId + '_Obligations_Next_Respondent_loading'] || props.formData?.[props.data.chartUniqueId + '_execute_obligation_Workflow_loading']) ? props.loader :
                                        allValues && allValues.map((data) => {
                                            return (
                                                <div key={data.value} style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '8px' }}>
                                                    <Checkbox
                                                        checked={selectedAssigneeId?.value === data.value}
                                                        onChange={() => setSelectedAssigneeId(data)}
                                                        color="primary"
                                                        inputProps={{ 'aria-label': `checkbox-${data.value}` }}
                                                    />
                                                    <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '8px' }}>
                                                        <AccountCircleIcon style={{ color: "rgba(48, 164, 97, 1)", height: '24px', width: '24px' }} />
                                                        <Typography
                                                            component='span'
                                                            style={{ fontWeight: '400', fontSize: '14px', color: 'rgba(33, 33, 33, 1)', fontStyle: 'medium', textAlign: 'center' }}
                                                        >
                                                            {data.label}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            )
                                        })
                                }

                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color='inherit'
                                size='small'
                                onClick={() => { onCloseModel() }}
                            >
                                Close
                            </Button>
                            <Button
                                style={{ backgroundColor: 'rgba(2, 136, 209, 1)', color: 'rgba(255, 255, 255, 1)' }}
                                size='small'
                                onClick={() => {
                                    if (selectedAssigneeId) {
                                        onAssignTo(selectedAssigneeId);
                                    }
                                }}
                            >
                                Assign
                            </Button>
                        </DialogActions>
                    </div>
                )
            }
            {
                modalInfo.type === 'assignToParent' && (
                    <div>
                        <DialogTitle id='customized-dialog-title'>
                            <Typography component='span' style={{ fontWeight: '600', fontSize: '14px', color: 'rgba(33, 33, 33, 1)', fontStyle: 'normal' }}>
                                {modalInfo.title}
                            </Typography>
                        </DialogTitle>
                        <DialogContent dividers>
                            <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                {
                                    (props.formData?.[props.data.chartUniqueId + '_Current_Steps_Members_loading'] || props.formData?.[props.data.chartUniqueId + '_Obligations_Step_Assigning_Upated_loading']) ? props.loader :
                                        defaultOptionsDropdown && defaultOptionsDropdown.map((data) => {
                                            return (
                                                <div key={data.value} style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '8px' }}>
                                                    <Checkbox
                                                        checked={selectedAssigneeId?.value === data.value}
                                                        onChange={() => setSelectedAssigneeId(data)}
                                                        color="primary"
                                                        inputProps={{ 'aria-label': `checkbox-${data.value}` }}
                                                    />
                                                    <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '8px' }}>
                                                        <AccountCircleIcon style={{ color: "rgba(48, 164, 97, 1)", height: '24px', width: '24px' }} />
                                                        <Typography
                                                            component='span'
                                                            style={{ fontWeight: '400', fontSize: '14px', color: 'rgba(33, 33, 33, 1)', fontStyle: 'medium', textAlign: 'center' }}
                                                        >
                                                            {data.label}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            )
                                        })
                                }

                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color='inherit'
                                size='small'
                                onClick={() => { onCloseModel() }}
                            >
                                Close
                            </Button>
                            <Button
                                style={{ backgroundColor: 'rgba(2, 136, 209, 1)', color: 'rgba(255, 255, 255, 1)' }}
                                size='small'
                                onClick={() => {
                                    if (selectedAssigneeId) {
                                        onAssignToParent(selectedAssigneeId);
                                    }
                                }}
                            >
                                Assign
                            </Button>
                        </DialogActions>
                    </div>
                )
            }

        </Dialog >
    );
};

export default WorkFlowModelViewer
